import { CSSTransition } from 'react-transition-group';
import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg1.png';

import { Pizza } from './components/Pizza/Pizza';
import { useState } from 'react';

function App() {
  const {
    currentState,
    isVisible,
    prevStateRef,
    prizes,
    countPrizes,
    setCountPrizes,
  } = useCarousel();

  const { bg, bgColor, speedRotate } = useGetParams();

  const [flag, setFlag] = useState(false);

  return (
    <div
      className="app-wrapper"
      style={{
        background:
          bg && bg !== '0'
            ? `url(${
                bg === '1' ? defaultBackground : bg
              })center/cover no-repeat, ${bgColor}`
            : `none, ${bgColor}`,
      }}
    >
      <CSSTransition
        in={isVisible && Boolean(currentState)}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
      >
        <Pizza
          currentState={currentState}
          prevStateRef={prevStateRef}
          prizes={prizes}
          countPrizes={countPrizes}
          setCountPrizes={setCountPrizes}
          speedRotate={speedRotate}
          isVisible={isVisible}
          setFlag={setFlag}
          flag={flag}
        />
      </CSSTransition>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
